import { useMediaQuery } from '@material-ui/core';

export const getDeskMinWidth = () => window.deskMinWidth;
export function useDeskMediaQuery() {
  return useMediaQuery(`(min-width:${getDeskMinWidth()}px)`, { noSsr: true });
}
